import { Action } from '@ngrx/store';

export enum CountryActionTypes {
  LoadCountrys = '[Country] Load Countrys',
  GetCountrys = '[Country] Get Countrys',
  GetCountrysFail = '[Country] Get Countrys Fail',
}

export class LoadCountrys implements Action {
  readonly type = CountryActionTypes.LoadCountrys;
  constructor(public payload: any[] ) {}
}

export class GetCountrys implements Action {
  readonly type = CountryActionTypes.GetCountrys;
}

export class GetCountrysFail implements Action {
  readonly type = CountryActionTypes.GetCountrysFail;
}


export type CountryActions = LoadCountrys
  | GetCountrys
  | GetCountrysFail;
